import React from 'react'
import classNames from 'classnames'

import { withStyles, createStyles, WithStyles, Theme } from '@material-ui/core'

import { IUserInfoResponse } from 'protos'

import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import CircularProgress from '@material-ui/core/CircularProgress'

import T from 'components/FormattedMessage'
import Button from 'components/Button'
import Currency from 'components/Currency'
import Countdown from 'components/Countdown'

import dailyBonusIcon from './assets/daily_bonus_icon.svg'

export interface Props {
  value?: IUserInfoResponse['bonusValue']
  className?: string
  isLoading?: boolean
  remainingSec?: IUserInfoResponse['bonusRemainingSec']
  onButtonClick?: () => void
  onCountdownFinished?: () => void
}

const styles = (theme: Theme) => createStyles({
  root: {
    padding: theme.spacing() * 3,
  },
  img: {
    verticalAlign: 'middle',
  },
})

type InjectedProps = Props & WithStyles<typeof styles>

const StoreDailyBonusBar: React.SFC<InjectedProps> = ({
  value,
  classes,
  className,
  isLoading,
  remainingSec,
  onButtonClick,
  onCountdownFinished,
}) => {
  if (!(!!value || !!remainingSec || isLoading)) {
    return null
  }

  return (
    <Grid
      className={classNames(className, classes.root)}
      alignItems="center"
      direction="row"
      justify="space-between"
      container
    >
      <Grid item>
        <Grid spacing={1} alignItems="center" direction="row" container>
          <Grid item>
            <img className={classes.img} src={dailyBonusIcon} alt="Daily Bonus" />
          </Grid>
          <Grid item>
            <Typography>
              {remainingSec
                ? <T id="store_bonus_waiting" />
                : <T id="store_bonus_available" />}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <Button
          size="small"
          color="primary"
          variant="contained"
          onClick={onButtonClick}
          disabled={isLoading || !!remainingSec}
        >
          {isLoading && (
            <CircularProgress size={18} color="inherit" />
          )}

          {!isLoading && !remainingSec && (
            <T
              id="store_bonus_claim"
              values={{
                bonus: <Currency {...value} />
              }}
            />
          )}

          {!isLoading && !!remainingSec && (
            <Countdown remainingSec={remainingSec} onFinished={onCountdownFinished} />
          )}
        </Button>
      </Grid>
    </Grid>
  )
}

export default withStyles(styles)(StoreDailyBonusBar)
